/* unplugin-vue-components disabled */import { render } from "./inspireBonus.vue?vue&type=template&id=0d1a0258&scoped=true"
import script from "./inspireBonus.vue?vue&type=script&lang=js"
export * from "./inspireBonus.vue?vue&type=script&lang=js"

import "./inspireBonus.vue?vue&type=style&index=0&id=0d1a0258&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1a0258"]])

export default __exports__